import { render, staticRenderFns } from "./SubRoomResizer.vue?vue&type=template&id=10288d22&scoped=true"
import script from "./SubRoomResizer.vue?vue&type=script&lang=ts"
export * from "./SubRoomResizer.vue?vue&type=script&lang=ts"
import style0 from "./SubRoomResizer.vue?vue&type=style&index=0&id=10288d22&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10288d22",
  null
  
)

export default component.exports